import { render, staticRenderFns } from "./epms9020.vue?vue&type=template&id=c48d6624&scoped=true"
import script from "./epms9020.vue?vue&type=script&lang=js"
export * from "./epms9020.vue?vue&type=script&lang=js"
import style0 from "./epms9020.vue?vue&type=style&index=0&id=c48d6624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48d6624",
  null
  
)

export default component.exports